<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

          <div class="card-header flex-wrap pt-6 pb-0">
            <div class="card-title">
              <div class="card-label">
                <h3 class="card-label mb-2">{{title }}</h3>
                <p class="fs-6" v-html="orderByName"></p>
              </div>
            </div>
            <div class="card-toolbar">
              <ButtonDropdownFilter
                    :btnTitle="$t('performance.order.orderBy')"
                    :search="false"
                    :options="criterias"
                    value-field="value"
                    :name-field="locale"
                    v-model="query.orderBy"
                  />
                  <ButtonDropdownFilter
                    :btnTitle="$t('performance.projects')"
                    :search="false"
                    :options="projects"
                    value-field="id"
                    name-field="title"
                    v-model="query.project_id"
                  />

            </div> 
        </div>
        <Loader :is-loading="loading">
          <div class="card-body">
            <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="performance_customer_datatable">
              <thead class="mb-5">
                <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                    <th class="w-50px text-center">{{ $t("performance.table.position") }} </th>
                    <th class="text-center">{{ $t('performance.table.collaborator') }} </th>
                    <th class="text-center">{{ $t('performance.table.folders')}}</th>
                    <th class="text-center">{{ $t("performance.table.alerts") }}</th>
                    <th class="text-center">{{ $t("performance.table.alarms") }}</th>
                    <th class="text-center">{{ $t("performance.table.lateTask") }}</th>
                    <th class="text-center">{{ $t("performance.table.doneTasks") }}</th>
                    <th class="text-center">{{ $t('performance.table.donePercent') }}</th>
                </tr>
              </thead>
            </table>
          </div>
        </Loader>
        
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import Loader from '@/components/Loader.vue';
import { useLocales } from '@/composables/locales';
import { computed, watch, onMounted, ref, nextTick} from 'vue';
import { useStore } from 'vuex';

const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})

const table = ref('')
const query = ref({
  project_id: "",
  startDate: "",
  endDate: "",
  orderBy: '',
})

const orderByName = computed(() => {
  let selected = criterias.value?.filter(el => el.value === query.value.orderBy)

  if(selected?.length > 0) return (`<span class="text-muted">${i18n.global.t('performance.order.orderby')?.toLowerCase()}: </span>` + selected[0][locale.value])?.toLowerCase()

  return ''
})

const projects = computed(() => store.getters['projects/getProjectsCollection'])
const criterias = computed(() => store.getters['projects/getUserPerformCriterias'])


watch(() => query.value, (value) => {
  nextTick(() => loadData())
}, { deep: true })

watch(() => locale.value, (value) => {
  nextTick(() => loadData())
}, { deep: true })

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

function loadData(){
  if (!query.value.startDate || !query.value.endDate) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats(
          {id:props.id,startDate: query.value.startDate, endDate: query.value.endDate, project_id: query.value.project_id, orderBy: query.value.orderBy}
        ).then((res) => { 
          fetchDatas(res?.response?.data)
        }),
        store.dispatch("projects/loadProjectsCollection"),
        store.dispatch("projects/loadUserPerformCriteria")
    
    ]).then(() => {
    })
}


async function fetchDatas(data) {

  const element = document.getElementById("performance_customer_datatable");

  if (element) {
    
    if ($.fn.dataTable.isDataTable(element)) {
      $(element).DataTable().clear().destroy();
    }

    table.value = $(element).DataTable({
      data: data,
      responsive: true,
      processing: true,
      serverSide: false,
      pageLength: Ls.get('pageLength') ?? 10,
      lengthMenu: [5, 10, 25, 50, 75, 100],
      order: [[1, 'desc']],
      columns: [
        { data: "rank" }, { data: "name" }, { data: "project_count" },
        { data: "alert_count" }, { data: "critical_alert_count" },
        { data: "late_task_count" }, { data: "completed_task_count" },
        { data: "percentage_completed" }
      ],
      columnDefs: [
        {
          targets: 0,
          orderable: false,
          className: "dt-center text-center clickable",
          render: (t, a, e) => `<span class="badge badge-primary" data-id="${e.id}">${t}</span>`
        },
        ...[1,2,3,4,5,6].map(i => ({
          targets: i,
          orderable: true,
          className: "dt-center text-center clickable",
          render: (t, a, e) => `<span data-id="${e.id}">${t}</span>`
        })),
        {
          targets: 7,
          orderable: true,
          className: "dt-center text-center",
          render: (t, a, e) => `<span data-id="${e.id}">${t}</span>`
        }
      ],
      language: {
        url: datatableLocaleUrl.value,
      }
    });
  }
}


onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})
</script>